export default (state = {}, action) => {
    switch (action.type) {
        case 'LOAD_API':
            return {
                ...state,
                isApiLoaded: action.payload,
            };
        case 'GET_REMOTE_CALENDAR':
            return {
                ...state,
                remoteCalendar: action.payload,
            };
        case 'GET_REMOTE_EVENTS':
            return {
                ...state,
                remoteEvents: action.payload,
            };
        case 'GET_SUPPORT_EVENTS':
            return {
                ...state,
                supportEvents: action.payload,
            };
        case 'GET_VACATION_EVENTS':
            return {
                ...state,
                vacationEvents: action.payload,
            };
        case 'GET_RELEASE_EVENTS':
            return {
                ...state,
                releaseEvents: action.payload,
            };
        case 'GET_MEETING_AVAILABILITY':
            return {
                ...state,
                meetingRoomAvailability: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/calendar.js